<insert-edit-number [fieldName]="fieldName" [label]="label" [required]="required" [digits]="2" prefix="€"></insert-edit-number>
